import { render, staticRenderFns } from "./uploadShipmentDocumentModal.vue?vue&type=template&id=6a7a0d68&"
import script from "./uploadShipmentDocumentModal.vue?vue&type=script&lang=js&"
export * from "./uploadShipmentDocumentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports